import { SYSTEM_USER, preloadWebItemLocation } from '@confluence/web-item-location';

export const preloadProfileMenu = () => {
	return preloadWebItemLocation({ location: SYSTEM_USER });
};
